// @faqrun/shared - Common types and utilities

export type HealthStatus = {
  status: "ok" | "error";
  timestamp?: string;
};

export * from "./errors";

export { METRIC_CODES, VALID_METRIC_CODES } from "./entitlement";
export type { MetricCode } from "./entitlement";

export { formatMonthlyPrice } from "./pricing";
